export enum AgreementName {
  RWT = 'rwt',
  PAYMENT = 'payment',
}
